import * as selectors from './general.selectors';
import reducer from './general.reducers';

export default reducer;
export { selectors, reducer };
export { GeneralAction } from './general.actions';
export { GeneralEffects } from './general.effects';
export { GeneralState } from './general.models';
export { GeneralService } from './general.service';
